/*eslint react-hooks/exhaustive-deps: "off"*/
/*eslint no-unused-vars: "off"*/
import React, { useEffect, useState } from "react";
import MapBase from "./MapBase";
import { PALETTE_YlOrRd_9, TRANSPARENT_COLOR } from "../../utils/Palette";
import useMapProps from "./useMapProps";
import { MapPropsProvider } from "./MapPropsContext";
import WidgetContainer from "./widgets/WidgetContainer";
import {
  arrayToRgb,
  getApiUrl,
  getLastYear,
  makeTableSorterFn,
  numberWithCommas,
} from "../../utils";
import WidgetClsCodeForStats from "./widgets/WidgetClsCodeForStats";
import RMateChartStatsStation from "./r_mate_chart/RMateChartStatsStation";
import WidgetLegend from "./widgets/WidgetLegend";
import Seperator from "./widgets/Seperator";
import WidgetStatisticsTable from "./widgets/WidgetStatisticsTable";
import WidgetSelectYearDetail from "./widgets/WidgetSelectYearDetail";
import WidgetRisingTabs from "./widgets/WidgetRisingTabs";
import WidgetDistrictSelect from "./widgets/WidgetDistrictSelect";
import WidgetToolbar from "./widgets/WidgetToolbar";
import { WELL_KNOWN_POSITION } from "../../Constants";
import AlignRightText from "./widgets/AlignRightText";

/**
 * 무선국 현황
 * 지도 + 통계
 */

function MapStatsStation() {
  const [fillColorLegend, setFillColorLegend] = useState([]);

  const mapProps = useMapProps({
    INITIAL_VIEW_STATE: {
      ...WELL_KNOWN_POSITION.세종특별자치시,
      zoom: 8,
    },
    INITIAL_GEOJSON_EXTRA_PARAMS: {
      checkStartYear: getLastYear() - 5,
      checkStartMonth: 1,
      checkEndYear: getLastYear(),
      checkEndMonth: 12,
      currentDistrictCode: "",
    },
    INITIAL_GEOJSON_POLYGON_LAYER_PROPS: {
      getHoverHtml: (object, mapDistrictStats) => {
        const [metricObject] = mapDistrictStats;
        const {
          properties: { pk, name },
        } = object;
        const code = pk;
        const obj = metricObject[code];
        if (obj) {
          const { total } = obj;
          return `<span class='fontStyle'>${name}</span><br/>
                  무선국 수 : ${numberWithCommas(total)} 개`;
        }
        // metricObject에 없더라도 호버를 띄워줍니다.
        return `<span class='fontStyle'>${name}</span><br/>
                무선국 수 : 0 개`;
      },
      getLevelFillColor: ({ properties: { pk } }, mapDistrictStats) => {
        const [metricObject, metricMax] = mapDistrictStats;
        const code = pk;
        const obj = metricObject[code];
        // 데이터가 없더라도 색을 입힙니다.
        if (obj) {
          const { total } = metricObject[code] || { total: 1 };
          if (total >= 1) {
            const index = Math.floor(
              (PALETTE_YlOrRd_9.length * (total - 1)) / metricMax
            );
            return [...PALETTE_YlOrRd_9[index].slice(0, 3), ...[200]];
          }
          return TRANSPARENT_COLOR;
        }
        return TRANSPARENT_COLOR;
      },
    },
    INITIAL_WIDGET_STATE: {
      cls_code_stats_list: [
        "32",
        "94",
        "44",
        "85",
        "49",
        "92",
        "42",
        "41",
        "21",
        "CMFL",
        "OTHER",
      ],
      isRangeByYear: false, // 기간조회를 기본으로 설정 2008~2018 형식.
    },
  });

  const {
    widgetState,
    dataResponseList,
    mapDistrictStats,
    setMapDistrictStats,
    isChangedMapDistrictStats,
    clickedPolygonGeojsonObjects,
    geojsonExtraParams,
    setChartAjaxParams,
    setGeojsonExtraParams,
    currentDistrictCode,
    setCurrentDistrictCode,
    chartDivVisible,
    setTableAjaxParams,
  } = mapProps;

  /*
  서버 Ajax 통신을 위해 json을 만듭니다.
  */

  const settingChkRadSvcString = (checkList) => {
    // const keys = "CHK_VALUE";
    let JSONList = {
      data: [],
    };
    for (let value of checkList) {
      const jsonValue = { CHK_VALUE: value };
      JSONList.data.push(jsonValue);
    }
    return JSON.stringify(JSONList);
  };

  // let paramSidoCode = "";
  let paramSearchStart = "";
  let paramSearchEnd = "";
  let paramSearchChk = "";
  let paramChkRadClsString = "";

  useEffect(() => {
    if (chartDivVisible) return;
    const { cls_code_stats_list, isRangeByYear } = widgetState;
    const metricObject = {};

    if (dataResponseList.length > 0 && cls_code_stats_list.length > 0) {
      const firstDataLayer = dataResponseList[0];
      // eslint-disable-next-line no-unused-vars
      for (let [code, stats] of Object.entries(firstDataLayer)) {
        let total = 0;
        const firstCode = firstDataLayer[code];
        for (let division_code of cls_code_stats_list) {
          const codeVal = firstCode[division_code];
          if (codeVal) {
            total += codeVal;
          }
        }
        metricObject[code] = { total };
      }
    }
    const metricMax = Math.max(
      ...Object.values(metricObject).map((obj) => obj.total)
    );

    const newMapDistrictStats = [metricObject, metricMax];
    if (isChangedMapDistrictStats(newMapDistrictStats)) {
      setMapDistrictStats(newMapDistrictStats);

      // ajax 통신을 위한 변수 설정
      // 연도
      const { checkStartYear, checkStartMonth, checkEndYear, checkEndMonth } =
        geojsonExtraParams;

      let paramStartMonth = "";
      let paramEndMonth = "";

      if (checkStartMonth < 10) {
        paramStartMonth = "0" + checkStartMonth.toString();
      } else {
        paramStartMonth = checkStartMonth.toString();
      }

      if (checkEndMonth < 10) {
        paramEndMonth = "0" + checkEndMonth.toString();
      } else {
        paramEndMonth = checkEndMonth.toString();
      }

      paramSearchStart = checkStartYear.toString() + paramStartMonth;
      paramSearchEnd = checkEndYear.toString() + paramEndMonth;

      // ajax sidocode
      const paramSidoCode =
        (currentDistrictCode || "").length < 2
          ? ""
          : currentDistrictCode.substr(0, 2);

      // 조회방식 Y 기간조회 2008~2018
      if (!isRangeByYear) paramSearchChk = "Y";
      else paramSearchChk = "N";

      // ajax 쿼리스트링
      paramChkRadClsString = settingChkRadSvcString(cls_code_stats_list);

      setChartAjaxParams({
        sidoCode: paramSidoCode,
        searchStart: paramSearchStart,
        searchEnd: paramSearchEnd,
        searchChk: paramSearchChk, // 기간조회 = Y
        chkRadClsString: paramChkRadClsString,
        prmCheckList: cls_code_stats_list,
      });
    } else {
      // 기간조회 <->상세조회 토글시에도 차트 불러오기위해 조건문 추가 -> Axios통신시 바뀌었는지 확인하는 로직도 추가하였습니다.
      const { checkStartYear, checkStartMonth, checkEndYear, checkEndMonth } =
        geojsonExtraParams;

      let paramStartMonth = "";
      let paramEndMonth = "";

      if (checkStartMonth < 10) {
        paramStartMonth = "0" + checkStartMonth.toString();
      } else {
        paramStartMonth = checkStartMonth.toString();
      }

      if (checkEndMonth < 10) {
        paramEndMonth = "0" + checkEndMonth.toString();
      } else {
        paramEndMonth = checkEndMonth.toString();
      }

      const searchStart = checkStartYear.toString() + paramStartMonth;
      const searchEnd = checkEndYear.toString() + paramEndMonth;
      let searchChk = "";

      if (isRangeByYear) {
        // true = 연도상세
        searchChk = "N";
      } else if (!isRangeByYear) {
        searchChk = "Y";
      }

      setChartAjaxParams((prev) => ({
        ...prev,
        searchChk,
        searchStart,
        searchEnd,
      }));
    }
  }, [dataResponseList, widgetState, geojsonExtraParams, currentDistrictCode]);

  useEffect(() => {
    if (chartDivVisible) return;
    if (clickedPolygonGeojsonObjects.length > 0) {
      const firstLayer = clickedPolygonGeojsonObjects[0];
      const {
        properties: { name, pk },
      } = firstLayer;
      if (pk && pk.length <= 2) {
        setCurrentDistrictCode(pk);
      }
    }
  }, [clickedPolygonGeojsonObjects]);

  useEffect(() => {
    if (chartDivVisible) return;
    const [metricObject, metricMax] = mapDistrictStats;
    if (window.isFinite(metricMax) && metricMax >= 9) {
      setFillColorLegend(
        [...Array(9).keys()]
          .map((colorIndex) => {
            const boundary = (metricMax / 9) * (colorIndex + 1);
            const index = Math.floor(
              (PALETTE_YlOrRd_9.length * (boundary - 1)) / metricMax
            );
            const colorRgb = arrayToRgb(PALETTE_YlOrRd_9[index]);
            return [colorRgb, boundary];
          })
          .reverse()
      );
    }
  }, [mapDistrictStats]);

  useEffect(() => {
    if (chartDivVisible) return;
    setGeojsonExtraParams((prev) => ({
      ...prev,
      currentDistrictCode,
      //currentDistrictCode: ((currentDistrictCode && currentDistrictCode.length <= 2) ? currentDistrictCode : currentDistrictCode.substr(0, 2)),
    }));
  }, [currentDistrictCode]);

  useEffect(() => {
    const {
      checkStartYear,
      checkStartMonth,
      checkEndYear,
      checkEndMonth,
      currentDistrictCode,
    } = geojsonExtraParams;
    let paramStartMonth = "";
    let paramEndMonth = "";

    if (checkStartMonth < 10) {
      paramStartMonth = "0" + checkStartMonth.toString();
    } else {
      paramStartMonth = checkStartMonth.toString();
    }

    if (checkEndMonth < 10) {
      paramEndMonth = "0" + checkEndMonth.toString();
    } else {
      paramEndMonth = checkEndMonth.toString();
    }

    paramSearchStart = checkStartYear.toString() + paramStartMonth;
    paramSearchEnd = checkEndYear.toString() + paramEndMonth;

    setTableAjaxParams({
      searchStart: paramSearchStart,
      searchEnd: paramSearchEnd,
      sidoCode: currentDistrictCode,
    });
  }, [geojsonExtraParams]);

  return (
    <MapPropsProvider value={mapProps}>
      <MapBase
        isHideWidgetToggleClustering={true}
        isHideWidgetMapLayerTypes={true}
      >
        <WidgetContainer>
          <div>
            <WidgetDistrictSelect
              isShowDistrictLayerFromGeoserver={true}
              onlyLv1={true}
            />
            <WidgetSelectYearDetail />
            {/*<WidgetYearToMonth/>*/}
            <Seperator />
            <WidgetClsCodeForStats />
          </div>
        </WidgetContainer>
      </MapBase>

      <WidgetRisingTabs
        titleOnInit={["지역별 국종별 무선국 수", "년간 국종별 무선국 수 변동"]}
        height={630}
      >
        <WidgetStatisticsTable
          fetchUrl={getApiUrl({ type: "type1" })}
          pageSize={20}
          type={"type1"}
          getTitle={(layer) => `지역별 국종별 무선국 수`}
          processor={(objectList) => {
            const gugunList = Array.from(
              new Set(objectList.map(({ gugun }) => gugun))
            );
            const clsNameList = Array.from(
              new Set(objectList.map(({ cls_name }) => cls_name))
            );

            const rowList = clsNameList.map((ref_cls_name) => {
              return objectList
                .filter(({ cls_name }) => cls_name === ref_cls_name)
                .reduce(
                  (acc, { gugun, cnt }) => {
                    acc[gugun] = cnt;
                    return acc;
                  },
                  { cls_name: ref_cls_name }
                );
            });

            const columns = gugunList.map((gugun) => ({
              title: gugun,
              dataIndex: gugun,
              key: gugun,
              // sorter: makeTableSorterFn(gugun),
              render: (text) => AlignRightText({ text, numberComma: true }),
              width: 120,
            }));

            return [columns, rowList];
          }}
          columns={[
            {
              title: "순번",
              dataIndex: "index",
              key: "index",
              width: 75,
              // sorter: makeTableSorterFn("index"),
              // fixed: "left",
            },
            {
              title: "국종명",
              dataIndex: "cls_name",
              key: "cls_name",
              width: 150,
              // sorter: makeTableSorterFn("cls_name"),
              // fixed: "left",
            },
          ]}
        />

        <WidgetStatisticsTable
          fetchUrl={getApiUrl({ type: "type3" })}
          type={"type3"}
          getTitle={(layer) => `년간 국종별 무선국 수 변동`}
          processor={(objectList) => {
            const yearList = Array.from(
              new Set(
                objectList
                  .filter(({ year }) => year !== undefined)
                  .map(({ year }) => year)
              )
            );
            const clsNameList = Array.from(
              new Set(objectList.map(({ cls_name }) => cls_name))
            );

            const rowList = clsNameList.map((ref_cls_name) => {
              return objectList
                .filter(({ cls_name }) => cls_name === ref_cls_name)
                .reduce(
                  (acc, { year, cnt }) => {
                    acc[year] = cnt;
                    return acc;
                  },
                  {
                    cls_name:
                      ref_cls_name === undefined ? "합계" : ref_cls_name,
                  }
                );
            });

            const columns = yearList.map((year) => ({
              title: year,
              dataIndex: year,
              key: year,
              sorter: makeTableSorterFn(year),
              render: (value) =>
                value && (
                  <div style={{ textAlign: "right" }}>
                    {numberWithCommas(value)}
                  </div>
                ),
            }));

            return [columns, rowList];
          }}
          columns={[
            {
              title: "순번",
              dataIndex: "index",
              key: "index",
              width: 75,
              // sorter: makeTableSorterFn("index"),
              // fixed: "left",
            },
            {
              title: "국종명",
              dataIndex: "cls_name",
              key: "cls_name",
              width: 150,
              // sorter: makeTableSorterFn("cls_name"),
              // fixed: "left",
            },
            // {title: '합계', dataIndex: 'total', key: 'total', sorter: makeTableSorterFn('total'),
            //   render: value => value && <div style={{textAlign: 'right'}}>{numberWithCommas(value)}</div>,
            // },
          ]}
        />
      </WidgetRisingTabs>
      <RMateChartStatsStation
        disabled={widgetState.cls_code_stats_list.length === 0}
      />
      {fillColorLegend.length > 0 && (
        <WidgetLegend
          fillColorLegend={fillColorLegend}
          titleColorLegend={"무선국 수"}
          unitColorLegend={"개"}
        />
      )}
      <WidgetToolbar />
    </MapPropsProvider>
  );
}

export default MapStatsStation;
